import { pathIsUnder } from '@hopdrive/feature-portal-products';
import { productRootPath } from '@features/products/productRoutes';

export interface InboundReturnsScope {
  /** The Parts Delivery routes are mounted for this rooftop (`isProductRouteMounted`). */
  routeMounted: boolean;
  /** The current `location.pathname`. */
  pathname: string;
  /** The rooftop the count is read for; absent until the session resolves one. */
  customerId: number | undefined;
}

/**
 * Whether the Returns badge count should be fetched right now.
 *
 * The dealer reads this count inside `PartsDeliveryShellLayout`, so it is scoped to
 * `/parts-delivery/*` by where it is mounted. The embed inlines that layout's body into
 * `AppRoutes` (decision S9), which put the read at APP scope — it fired on every route, on every
 * page load, for any rooftop holding the product. This restores the dealer's scope from the
 * pathname instead, so `AppRoutes` can keep one shape for all four product blocks.
 *
 * Its caller must still call the query hook unconditionally and pass `!shouldFetchInboundReturns(…)`
 * as `skip` — the scope is a skip, never a conditional hook.
 */
export function shouldFetchInboundReturns({ routeMounted, pathname, customerId }: InboundReturnsScope): boolean {
  if (!routeMounted) return false;
  if (!customerId) return false;
  return pathIsUnder(productRootPath('parts-delivery'), pathname);
}
